<template>
  <div class="ai-recommendations-list-border">
    <div class="ai-recommendations-list-title">Based on AI recommendations</div>

    <el-table
      :data="aiRecommendationList"
      :header-cell-style="{color:'#000000',fontFamily:'Satoshi-Medium !important',fontSize:'14px'}"
      stripe
      border>
      <el-table-column label="Store name" :width="width">
        <template slot-scope="scope">
          <div class="table-store-name-border">
            <div class="table-store-name-img"><img :src="scope.row.mainImg" @click="initPreview(scope,scope.row.mainImg)"/></div>
            <div class="table-store-name">
              <div class="table-store-name-title" @click="gotoReport(scope.row)">{{scope.row.storeName}}</div>
              <div class="table-store-name-text">{{scope.row.address}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="local pedestrian traffic"
        align="center"
        width="180">
        <template slot-scope="scope">
          {{formatNumber(scope.row.storeVisits)}}
        </template>
      </el-table-column>
      <el-table-column
        label="Ethnic composition"
        align="center"
        width="300">
        <template slot-scope="scope">
          <div class="echars" :ref="'echarts'+scope.row.id"></div>
        </template>
      </el-table-column>
      <el-table-column
        label="Store reviews"
        align="center"
        width="180">
        <template slot-scope="scope">
          <div class="table-store-reviews-border">
            <div class="table-store-score">{{parseFloat(scope.row.avgRating).toFixed(1)}}</div>
            <div class="table-store-rate">
              <el-rate
                v-model="scope.row.avgRating"
                disabled
                text-color="#F3E93D">
              </el-rate>
            </div>
            <div class="table-store-reviews">({{scope.row.reviews}})</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Store's images"
        width="300">
        <template slot-scope="scope">
          <div class="table-store-images-border">
            <!-- 如果大于三张使用 滚动-->
            <div v-if="scope.row.storeImgList && scope.row.storeImgList.length>3" class="table-store-images-swiper">
              <awesome-swiper
                :pagination="true"
                :turnPages="true"
                :swiperData="storeImg"
                :prevName="'storeImg'+scope.row.id"
                :nextName="'storeImg'+scope.row.id"
              >
                <swiper-slide v-for="(item, index) in scope.row.storeImgList" :key="index">
                  <img style="width: 76px;height: 58px;cursor:pointer;" :src="item" @click="initPreview(scope,item)">
                </swiper-slide>
              </awesome-swiper>
            </div>
            <!-- 如果小于三张则直接显示图片 -->
            <div v-if="scope.row.storeImgList && scope.row.storeImgList.length<=3" class="table-store-images">
              <img v-for="(item,index) in scope.row.storeImgList" :key="index" :src="item" @click="initPreview(scope,item)"/>
            </div>
          </div>

        </template>
      </el-table-column>
      <el-table-column label="Operation" width="120">
        <template slot-scope="scope">
          <div class="table-action" @click="gotoReport(scope.row)">Open Report</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="load-more-border" @click="$refs['loadMore'].init()">
      <div class="load-more-icon"><img src="@/assets/img/vilocal/ai-load-more.png"/></div>
      <div class="load-more-content">Load More</div>
    </div>
    <ImgPreview :src-list="storeImgList" ref="imgPreviewRef" />
    <AiRecommendationsUpgradePlan ref="loadMore"/>
  </div>
</template>

<script>
import { getAction } from '../../../api/manage'
import * as echarts from 'echarts'
import awesomeSwiper from '../../home/components/awesomeSwiper.vue'
import {swiperSlide} from 'vue-awesome-swiper'
import ImgPreview from '../img-preview.vue'
import AiRecommendationsUpgradePlan from './ai-recommendations-upgrade-plan.vue'

export default {
  components: {
    awesomeSwiper,
    swiperSlide,
    ImgPreview,
    AiRecommendationsUpgradePlan
  },
  data() {
    return {
      width: null,
      aiRecommendationList: [],
      storeImg: {
        slidesPerView: 3,
        spaceBetween: 10,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        loop: false
      },
      turnPages: true,
      pagination: true,
      storeImgList: []
    }
  },
  mounted() {
    if (window.screen.width <= 1440) {
      this.width = 400
    }
    // 获取信息
    this.getAIRecommendations()
  },
  methods: {
    formatNumber(number) {
      if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K'
      } else {
        return Number('0.' + (number % 1000)).toFixed(1) + 'K'
      }
    },
    initPreview(scope, item) {
      this.storeImgList = []
      let tempStoreImgList = []
      tempStoreImgList.push(...scope.row.storeImgList)
      this.storeImgList = tempStoreImgList
      this.$refs['imgPreviewRef'].init(item)
    },
    gotoReport(row) {
      var encrypt = btoa(row.storeId)
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${row.userId}&storeId=${encrypt}`)
      window.open(routeUrl.href, '_blank')
    },
    getAIRecommendations() {
      getAction('/brand/vilocal/api/v0.2/ai-recommendations').then(response => {
        if (response.success) {
          if (response.result) {
            let tempAiRecommendationList = []
            for (var index = 0; index < response.result.length; index++) {
              const aiRecommendationObject = response.result[index]
              aiRecommendationObject.id = index + 1
              tempAiRecommendationList.push(aiRecommendationObject)
            }
            this.aiRecommendationList = tempAiRecommendationList
            setTimeout(_ => {
              this.aiRecommendationList.forEach(e => {
                let myChart = echarts.init(this.$refs['echarts' + e.id])
                myChart.setOption(
                  {
                    tooltip: {
                      trigger: 'item',
                      position: 'inside',
                      formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    color: ['#7c24f4', '#2F66FB', '#30A5FB', '#C9FD33', '#FFF636', '#FEBA2B', '#FD6C21', '#FD3B1D'],
                    series: [
                      {
                        name: 'Ethnic Ratio',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                          show: false,
                          position: 'center'
                        },
                        emphasis: {
                          label: {
                            show: true,
                            fontSize: 10,
                            fontWeight: 'bold'
                          }
                        },
                        labelLine: {
                          show: false
                        },
                        data: e.ethnicOrigin
                      }
                    ]
                  }
                )
                window.addEventListener('resize', () => {
                  myChart.resize()
                })
              })
            }, 1000)
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ai-recommendations-list-border{
  margin-top: 30px;

}
.ai-recommendations-list-title{
  font-size: 14px;
  font-family: Satoshi-Bold !important;
  margin-bottom: 20px;
}
.table-store-name-border{
  display: flex;
  align-items: center;
  // margin-left: 5px;
  .table-store-name-img{
    width: 119px;
    height: 91px;
    img{
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
  .table-store-name{
    width: calc(100% - 119px);
    margin-left: 10px;
    .table-store-name-title{
      font-size: 14px;
      font-family: Satoshi-Bold !important;
      color: #000000;
      text-decoration: underline;
      cursor: pointer;
    }
    .table-store-name-text{
      font-size: 12px;
      font-family: Satoshi-Regular !important;
      color: #5D5D5D;
      margin-top: 10px;
    }
  }

}
.echars{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 120px;
  width: 300px;
}
.table-store-reviews-border{
  display: flex;
  align-items: center;
  .table-store-rate{
    margin-left: 5px;
  }
}
/deep/ .el-rate__icon{
  margin-right: 0px;
}
.table-action{
  height: 30px;
  background: #262B2F;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #FFFFFF;
}
.table-store-images{
  display: flex;
  align-items: center;
  padding-left: 25px;
  img{
    width: 66px;
    height: 58px;
    margin: 0px 5px;
    cursor: pointer;
  }
}
.table-store-images-swiper{
  padding: 0px 30px;
}
.load-more-border{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  cursor: pointer;
  .load-more-icon{
    height: 14.33px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .load-more-content{
    margin-left: 10px;
    color: #262B2F !important;
  }
}
/deep/ .el-table--border .el-table__cell{
  border-right:none
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/ai-recommendations/ai-recommendations-list.vue